import { OrganizationKeyName } from "../../model/Organization";
import { RegisterBeaconRequestLog } from "../../service/api-response/BeaconListSuccessResponse";
import { RootState } from "../../store";

import * as authSelectors from "../auth/authSelectors";

export const beaconsForCurrentOrganization = (
  state: RootState
): RegisterBeaconRequestLog[] => {
  const key = authSelectors.selectedOrganizationKeyName(state);
  if (!key || !state.beacon.beacons) {
    return [];
  }

  return state.beacon.beacons[key] || [];
};

export const isLoadingBeaconsForCurrentOrganization = (
  state: RootState
): boolean => {
  const key = authSelectors.selectedOrganizationKeyName(state);
  if (!key || !state.beacon.isBeaconsLoading) {
    return false;
  }

  return !!state.beacon.isBeaconsLoading[key];
};

export const hasMore = (
  state: RootState,
  org: OrganizationKeyName
): boolean => {
  const hasMoreBeacons = state.beacon.hasMoreBeacons[org];
  if (hasMoreBeacons === undefined) {
    return true;
  }

  return !!hasMoreBeacons;
};
